import { Component } from '@angular/core';
import { AlertController, NavController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { ApiService } from './../service/api.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public isStockMenuOpen: boolean = false; 
  public isCommodityMenuOpen: boolean = false;
  public isCryptoMenuOpen: boolean = false;
  private readonly PAGE_PASSWORD = 'tt123tt';
  constructor(  private storage: Storage ,
    private navCtrl: NavController,
    private alertController: AlertController,
    private toastController: ToastController,
    private apiService: ApiService
  ) {}
async openSecurePage(targetRoute: string) {
    const alert = await this.alertController.create({
      header: 'Security Check',
      message: 'Please enter the password to access this page.',
      backdropDismiss: false, // Forces the user to click a button
      inputs: [
        {
          name: 'password',
          type: 'password',
          placeholder: 'Enter Password',
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary'
        },
        {
          text: 'Proceed',
          handler: (data) => {
            if (data.password === this.PAGE_PASSWORD) {
              // Password is correct, navigate to the page
              this.navCtrl.navigateRoot(targetRoute);
              return true; 
            } else {
              // Password is wrong
              this.showErrorToast('Incorrect password. Access denied.');
              return false; // Prevents the alert from closing if you want them to try again, or return true to close it.
            }
          }
        }
      ]
    });

    await alert.present();
  }
  async showErrorToast(message: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
      color: 'danger',
      position: 'bottom'
    });
    toast.present();
  }

  toggleStockMenu() {
    this.isStockMenuOpen = !this.isStockMenuOpen;
  }

  // Toggle Function for Commodity
  toggleCommodityMenu() {
    this.isCommodityMenuOpen = !this.isCommodityMenuOpen;
  }

  toggleCryptoMenu() {
    this.isCryptoMenuOpen = !this.isCryptoMenuOpen;
  }

  async deleteAllScannerData() {
    const alert = await this.alertController.create({
      header: 'Confirm',
      message: 'Clear ALL cached besttrade/bestlasttrade/arbitrage data and the F&O Redis cache? (Lot Size list is not affected.)',
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Delete',
          handler: () => {
            this.apiService.deleteAllScannerData().subscribe({
              next: async () => {
                const toast = await this.toastController.create({
                  message: 'Scanner data cleared.',
                  duration: 2000,
                  color: 'success',
                  position: 'bottom'
                });
                toast.present();
              },
              error: () => this.showErrorToast('Failed to clear scanner data.')
            });
          }
        }
      ]
    });
    await alert.present();
  }

  async refreshFo() {
    const alert = await this.alertController.create({
      header: 'Confirm',
      message: 'Sync the Lot Size list against Fyers\' live F&O list? This adds new symbols, updates changed lot sizes, and removes symbols that no longer have F&O contracts.',
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Refresh',
          handler: () => {
            this.apiService.refreshFo().subscribe({
              next: async (res: any) => {
                const addedCount = res.added ? res.added.length : 0;
                const updatedCount = res.updated ? res.updated.length : 0;
                const removedCount = res.removed ? res.removed.length : 0;
                const toast = await this.toastController.create({
                  message: `F&O list synced. Added ${addedCount}, updated ${updatedCount}, removed ${removedCount}.`,
                  duration: 4000,
                  color: res.status === 'success' ? 'success' : 'danger',
                  position: 'bottom'
                });
                toast.present();
              },
              error: () => this.showErrorToast('Failed to refresh F&O list.')
            });
          }
        }
      ]
    });
    await alert.present();
  }


  logout() {
    this.storage.clear();
    this.navCtrl.navigateRoot('/signin');
    }

    
}


